export const PAGE_LOGIN = 'pg_login';
export const PAGE_HOME = 'pg_home';
export const PAGE_RESET_PASSWORD = 'pg_reset'
